export interface FrisokarLine {
  id: string;
  name: string;
  category: string;
  description: string;
  photos: string[];
  url: string;
}

export const frisokarLines: FrisokarLine[] = [
  {
    id: 'office-mona',
    name: 'Office Mona',
    category: 'Cadeira de Escritório',
    description: 'Design moderno com estrutura toda em tela, encosto de cabeça, braços e assento regulável. Apresentada na Formóbile 2024.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2024/06/5175.jpg',
      'https://www.frisokar.com.br/wp-content/uploads/2024/06/Mona-Alta-EC_01.jpg',
      'https://www.frisokar.com.br/wp-content/uploads/2024/06/Mona-Alta-EC_02.jpg',
      'https://www.frisokar.com.br/wp-content/uploads/2024/06/Mona-Alta-EC_03.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/cadeira-office-mona/',
  },
  {
    id: 'cadeira-duo',
    name: 'Cadeira Duo',
    category: 'Cadeira Sustentável',
    description: 'Revolução sustentável da Frisokar. Feita de dois polímeros 100% recicláveis, compacta e com programa Destino Certo para descarte responsável.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2024/07/5202.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/cadeira-duo/',
  },
  {
    id: 'sky',
    name: 'Sky',
    category: 'Cadeira Operativa',
    description: 'Linha que prioriza inovação e leveza, com duas alturas de encosto e múltiplas configurações. Perfeita para ambientes modernos e dinâmicos.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2018/06/sky_alta_02-300x300.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/cadeira-de-escritorio-sky/',
  },
  {
    id: 'poltrona-pix',
    name: 'Poltrona Pix',
    category: 'Poltrona Colaborativa',
    description: 'Poltrona para escritório com design colaborativo, estofamento em tecido de alta qualidade e estrutura em aço. Ideal para salas de espera e lounges.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2018/06/Pix_02-e1529499920931-300x300.png',
    ],
    url: 'https://www.frisokar.com.br/produto/poltrona-nacional-pix/',
  },
  {
    id: 'cadeira-up',
    name: 'Cadeira Up!',
    category: 'Cadeira Multiuso',
    description: 'Cadeira plástica multiuso com design premiado Good Design Award. Disponível em versão fixa, giratória e longarina. Leve, empilhável e em diversas cores.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2018/05/3308-300x300.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/cadeira-plastica-up/',
  },
  {
    id: 'poltrona-pipeline',
    name: 'Poltrona Pipeline',
    category: 'Frisokar Premium',
    description: 'Poltrona premium com design sofisticado, estofamento de alta qualidade e estrutura metálica. Perfeita para salas executivas e lounges corporativos.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2024/07/5534-300x300.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/poltrona-pipeline/',
  },
  {
    id: 'sofa-flow',
    name: 'Sofá Modular Flow',
    category: 'Frisokar Premium',
    description: 'Sofá modular para ambientes corporativos e colaborativos. Design contemporâneo com múltiplas configurações de módulos para criar espaços únicos.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2024/03/4163-300x300.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/sofa-modular-flow/',
  },
  {
    id: 'time',
    name: 'Time',
    category: 'Cadeira Executiva',
    description: 'Redefine o conforto com modelos fixos e giratórios, incluindo apoio de cabeça, porta-paletó e variadas opções de revestimento. Elegância e funcionalidade.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2024/03/PoltronaTime_03-300x300.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/cadeira-de-escritorio-time/',
  },
  {
    id: 'cadeira-fine',
    name: 'Cadeira Fine',
    category: 'Frisokar Premium',
    description: 'Novo modelo premium com design refinado, encosto em tela de alta performance e mecanismo ergonômico avançado. Lançamento 2025.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2025/09/Fine-Tela-EC-300x300.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/cadeira-escritorio-fine/',
  },
  {
    id: 'cadeira-vitrine',
    name: 'Cadeira Fixa Vitrine',
    category: 'Cadeira Multiuso',
    description: 'Cadeira fixa com design moderno e estrutura robusta. Ideal para salas de reunião, auditórios e ambientes de convivência corporativa.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2025/08/5720-300x300.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/cadeira-fixa-vitrine/',
  },
  {
    id: 'mesas-bistro-pix',
    name: 'Mesas Bistrô PIX',
    category: 'Mesas e Estantes',
    description: 'Mesas bistrô da linha PIX para ambientes colaborativos e de convivência. Design moderno com tampo redondo e base metálica em diversas alturas.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2024/03/4741-300x300.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/mesas-bistro-pix/',
  },
  {
    id: 'sofa-pix',
    name: 'Sofá Modular PIX',
    category: 'Sofás',
    description: 'Sofá modular da linha PIX para ambientes colaborativos. Combina conforto e versatilidade com múltiplas configurações de módulos.',
    photos: [
      'https://www.frisokar.com.br/wp-content/uploads/2018/07/Puff-Pix-com-encosto_02-e1534421264529-300x300.jpg',
    ],
    url: 'https://www.frisokar.com.br/produto/sofa-para-escritorio-pix-modular/',
  },
];
